__turbopack_context__.v({
  "container": "b4lhAq_container",
  "navBar": "b4lhAq_navBar",
  "orderFormatData": "b4lhAq_orderFormatData",
  "orderTypeIcon": "b4lhAq_orderTypeIcon",
  "whiteLabeled": "b4lhAq_whiteLabeled",
});
